import React from 'react';
import Hero from './Hero';
import FreeOffer from './FreeOffer';
import BioLink from './BioLink';
import Reviews from './Reviews';
import FAQ from './FAQ';
import Stats from './Stats';
import WorldMap from './WorldMap';
import CustomNavbar from '../user-managemnet/PublicNavbar';
import Footer from '../user-managemnet/Footer';


const HomePage = () => {
  return (
    <div className="homepage">
      <CustomNavbar />

      <div className='main-content'>
        {/* Hero Section */}
        <div id="home">
          <Hero />
        </div>
        {/* Website Details & Free Offering */}
        <div id="pricing">
          <FreeOffer />
        </div>

        {/* Bio Link Pages Section */}
        <div id="services">
          <BioLink />
        </div>

        {/* Reviews Section */}
        <Reviews />

        {/* FAQ Section */}
        <FAQ />

        {/* Stats Section */}
        {/* <Stats /> */}



        {/* World Map Section */}
        {/* <WorldMap /> */}
      </div>
      <div id="contact">
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
